import { useSearchParams } from "react-router-dom"
import { useAppDispatch, useAppSelector } from "../../../store/hooks"
import MainSectionWrapper from "../../UI/wrappers/MainSectionWrapper"
import { Spinner } from "../../UI/Spinner"
import AddressSettings from "./AddressSettings"
import TeamSettings from "./TeamSettings"
import WorkTimeSettings from "./WorkTimeSettings"
import { useEffect } from "react"
import { getCalendarSettings } from "../../../store/calendarSettings/action"

const GeneralSettingsTab = () => {
  const { calendarSettingsData, loading, error } = useAppSelector((state) => state.calendarSettingsSlice)
  const { activeNexusFilters } = useAppSelector(state => state.nexusFiltersSlice)
  const dispatch = useAppDispatch()
  const [searchParams] = useSearchParams();
  const filter = searchParams.get("filter");
  const filterId = activeNexusFilters?.find(x => x.id === parseInt(filter ?? "0"))?.filterId;

  useEffect(() => {
    if (!filterId) return;
    dispatch(getCalendarSettings({ filterId }));
  }, [dispatch, filterId])

  return !calendarSettingsData ? (
    <div className="flex flex-col gap-[10px] items-center justify-center h-full w-full">
      {loading && <Spinner />}
      {error && <p style={{ color: "var(--col-error-3)" }}>{error}</p>} {/* todo: error text */}
    </div>
  ) : (
    <>
      <MainSectionWrapper classes="border-b border-b-[var(--col-border-primary)]">
        <AddressSettings />
        <WorkTimeSettings />
      </MainSectionWrapper>

      <MainSectionWrapper>
        <TeamSettings />
      </MainSectionWrapper>
    </>
  )
}

export default GeneralSettingsTab